// src/api/apiClient.js

import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/api', // 你的 Nginx 代理路径
  withCredentials: true, // <-- 关键！让axios在跨域请求中自动发送和接收cookie
});

const authApiClient = axios.create({
  // 走主站同域反代 (/auth-api -> auth 服务)，使登录 Cookie 落在本域(終ノ空.com)，
  // 避免跨域到 auth.nightabyss.com 时 Cookie 无法被主站 /api 携带。
  baseURL: '/auth-api',
  withCredentials: true,
});
// 3. 导出两个客户端
export { apiClient, authApiClient };
